export type ProductType = "tshirt" | "gangsheet";

export interface ProductConfig {
  name: string;
  kind: "tshirt" | "gangsheet";
  image?: string; // garment render (omitted for the gang sheet)
  width?: number; // garment render width (px)
  sizeMm: { width: number; height: number }; // physical print size
  printArea: { x: number; y: number; width: number; height: number };
}

export const PRODUCTS: Record<ProductType, ProductConfig> = {
  tshirt: {
    name: "T-Shirt",
    kind: "tshirt",
    image: "/designer/tshirt.png",
    width: 620,
    sizeMm: { width: 280, height: 340 },
    printArea: { x: 350, y: 385, width: 280, height: 340 },
  },

  gangsheet: {
    name: "Gang Sheet",
    kind: "gangsheet",
    // A DTF gang sheet: 28 cm wide × 100 cm long. Designs are ganged onto it.
    sizeMm: { width: 280, height: 1000 },
    printArea: { x: 0, y: 0, width: 190, height: 680 },
  },
};
